import { Column, Spacer } from '../../components';
import { useDeviceType } from '../../hooks/useDeviceType';
import CancelContract from '../../components/CancelContract';
import { Box, Button } from '@mui/material';

interface ContractActionButtonsProps {
  agreeText: string;
  resumeAddPackage: boolean;
  reviewed: boolean | undefined;
  navBack: () => void;
  onSubmit: () => void;
}

export const ContractActionButtons: React.FC<ContractActionButtonsProps> = ({
  agreeText,
  resumeAddPackage,
  reviewed,
  navBack,
  onSubmit,
}) => {
  const { isMobile, isTablet } = useDeviceType();

  return isMobile || isTablet ? (
    <Column style={{ alignItems: 'center' }}>
      {!resumeAddPackage && (
        <>
          <CancelContract />
          <Spacer height='xs' />
        </>
      )}
      <Button className='mobile' onClick={onSubmit} color='primary' disabled={!reviewed}>
        {agreeText}
      </Button>
      <Spacer height='xs' />
      {resumeAddPackage ? (
        <CancelContract componentType='button' />
      ) : (
        <Button className='mobile' onClick={navBack} variant='outlined' color='secondary'>
          Back
        </Button>
      )}
    </Column>
  ) : (
    <Box
      style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'row',
      }}>
      <Box
        style={{
          display: 'flex',
          flex: 1,
          alignItems: 'center',
          justifyContent: 'flex-start',
        }}>
        {resumeAddPackage ? (
          <CancelContract componentType='button' />
        ) : (
          <Button className='back' onClick={navBack} variant='outlined' color='secondary'>
            Back
          </Button>
        )}
      </Box>
      <Box
        style={{
          display: 'flex',
          flex: 1,
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'flex-end',
        }}>
        {!resumeAddPackage && (
          <>
            <CancelContract />
            <Spacer width='sm' />
          </>
        )}
        <Button
          className='nextStep'
          onClick={onSubmit}
          color='primary'
          disabled={!reviewed}
          sx={{ whiteSpace: 'nowrap', flex: '0 0 250px' }}>
          {agreeText}
        </Button>
      </Box>
    </Box>
  );
};
